export function getMergeSortAnimations(array) {
  const animations = [];

  const mergeSort = (arr, l, r) => {
    if (l >= r) return;
    const m = Math.floor((l + r) / 2);
    mergeSort(arr, l, m);
    mergeSort(arr, m + 1, r);
    merge(arr, l, m, r);
  };

  const merge = (arr, l, m, r) => {
    const left = arr.slice(l, m + 1);
    const right = arr.slice(m + 1, r + 1);
    let i = 0, j = 0, k = l;

    while (i < left.length && j < right.length) {
      animations.push([k, k, 'compare']);
      if (left[i] <= right[j]) {
        arr[k] = left[i];
        animations.push([k, left[i], 'overwrite']);
        i++;
      } else {
        arr[k] = right[j];
        animations.push([k, right[j], 'overwrite']);
        j++;
      }
      k++;
    }

    while (i < left.length) {
      arr[k] = left[i];
      animations.push([k, left[i], 'overwrite']);
      i++;
      k++;
    }

    while (j < right.length) {
      arr[k] = right[j];
      animations.push([k, right[j], 'overwrite']);
      j++;
      k++;
    }
  };

  mergeSort(array, 0, array.length - 1);
  return animations;
}
